import actions from './actions';
const initState = {
    webStoreId: null,
    fetchingStoreProducts: false,
    fetchedStoreProducts: null,
    fetchStoreProductsFailed: null,
    fetchingStoreData: false,
    fetchedStoreData: null,
    fetchingStoreDatafailed: null,
    transactionDetails: {
        transaction: {
            request_id: "",
            notification_url: "",
            response_url: "",
            cancel_url: "",
            pmethod: "all",
            pchannel: "",
            payment_action: "url_link",
            collection_method: "single_pay",
            payment_notification_status: "1",
            payment_notification_channel: "1",
            amount: 0.00,
            currency: "PHP",
            signature: "",
        },
        customerChoosePmethod: true,
        customerInputInfo: true,
        customer_info: {
            fname: "",
            lname: "",
            mname: "",
            email: "",
            phone: "",
            mobile: "",
            dob: "",
            signature: ""
        },
        billing_info: {
            billing_address1: "",
            billing_address2: "",
            billing_city: "",
            billing_state: "",
            billing_country: "",
            billing_zip: ""
        },
        shipping_info: {
            shipping_address1: "",
            shipping_address2: "",
            shipping_city: "",
            shipping_state: "",
            shipping_country: "",
            shipping_zip: ""
        },
        storeId: null,
        order_details: {
            orders: [],
            subtotalprice: 0.00,
            shippingprice: 0.00,
            discountamount: 0.00,
            totalorderamount: 0.00
        }
    },
    checkoutLoading: false,
    checkoutTransaction: null,
    checkoutFailed: null,
};

export default function storeReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCHING_STORE_PRODUCTS:
            return {
                ...state,
                fetchingStoreProducts: true,
            };
        case actions.FETCHED_STORE_PRODUCTS:
            return {
                ...state,
                fetchingStoreProducts: false,
                fetchedStoreProducts: action.data,
                webStoreId: JSON.parse(action.webStoreId),
                transactionDetails: JSON.parse(action.transactionDetails),
            };
        case actions.FETCH_STORE_PRODUCTS_FAILED:
            return {
                ...state,
                fetchingStoreProducts: false,
                fetchStoreProductsFailed: action.message,
            };
        case actions.FETCHING_STORE_DATA:
            return {
                ...state,
                fetchingStoreData: true,
                fetchedStoreData:null,
            };
        case actions.FETCHED_STORE_DATA:
            return {
                ...state,
                fetchingStoreData: false,
                fetchedStoreData: action.result,
                //webStoreId: JSON.parse(action.webStoreId),
                //transactionDetails: JSON.parse(action.transactionDetails),
            };
        case actions.FETCH_STORE_DATA_FAILED:
            return {
                ...state,
                fetchingStoreData: false,
                fetchingStoreDataFailed: action.message,
            };
        case actions.ADDED_TO_CART:
            return {
                ...state,
                transactionDetails: action.transactionDetails && action.transactionDetails !== 'null' && action.transactionDetails !== undefined ? JSON.parse(action.transactionDetails) : state.transactionDetails,
            };
        case actions.SUBMITTING_TRX:
            return {
                ...state,
                checkoutLoading: true,
            };
        case actions.SUBMITTED_TRX:
            return {
                ...state,
                checkoutLoading: false,
                checkoutTransaction: action.payload,
            };
        case actions.SUBMIT_TRX_FAILED:
            return {
                ...state,
                checkoutLoading: false,
                checkoutTransaction: null,
                checkoutFailed: action.message,
            };
        case actions.SUBMIT_TRX_RESET:
            return {
                ...state,
                checkoutLoading: false,
                checkoutTransaction: null,
                checkoutFailed: null,
            };
        default:
            return state;
    }
}
